export const ACTIVE_DOT_SET = 'ACTIVE_DOT_SET'
export const ACTIVE_DOT_UNSET = 'ACTIVE_DOT_UNSET'
